window.Vue = require('vue');
window.$ = require('jquery');
import "slick-carousel";
import AOS from "aos";
import Cookies from "js-cookie";

Vue.component('pointsDeCollecte', require('./components/pointsDeCollecteComponent.vue').default);
Vue.component('mentionsLegales', require('./components/mentionsLegalesComponent.vue').default);
Vue.component('navMobile', require('./components/navMobile.vue').default);

const app = new Vue({
    el: '#app'
});

AOS.init({
    duration: 1000
});

require('./map');

const $links = $('header nav a[href^="/#"]')
$links.click(function() {
    const page = $(this).attr('href')
    var speed = 750
    $('html, body').animate( { scrollTop: $(page.slice(1)).offset().top }, speed )
	return false
})

$('body').on('click', '.top', function() {
    const page = $(this).attr('href')
    var speed = 750
    $('html, body').animate( { scrollTop: $(page).offset().top }, speed )
	return false
})

const $slider = $('#slider .slider');
if ($slider) {
    $slider.slick({
        speed: 1000,
        dots: true,
        infinite: true,
        autoplay: true,
        fade: true,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false
                }
            }
        ]
    });
}

const $headerSlider = $('#header-slider');
if ($headerSlider) {
    $headerSlider.slick({
        arrows: false,
        speed: 1000,
        dots: true,
        infinite: true,
        autoplay: true,
        fade: true,
        autoplaySpeed: 4000
    });
}

const $collecteHover = $('[data-hover="apparaître-collecte"]');
if ($collecteHover) {
    $collecteHover.hover(function() {
        $(this).children('div:last-child').css({
            opacity: 1,
            transitionDuration: '.5s',
            height: 'auto',
            width: 'auto',
            padding: '1.5rem 1rem'
        });
    }, function() {
        $(this).children('div:last-child').css({
            opacity: 0,
            transitionDuration: '0s',
            height: 0,
            width: 0,
            padding: '0 0'
        });
        
    });
}

//RGPD
//Show Cookie Banner
$(document).on('click','.show-cookie-banner',function(e){
    e.preventDefault();
    document.getElementById("elc-cookie-consent").classList.remove('elc-hidden');
    document.getElementById("elc-cookie-tab").classList.remove('elc-hidden');

    document.getElementById("elc-cookie-consent").classList.add('elc-fullwidth');
    document.getElementById("elc-cookie-consent").classList.remove('elc-small');
});

//Gestion des cookies Analytics
if(typeof removeGACookies != "undefined" && removeGACookies){
    Cookies.remove("_gid",{ path: "/", domain: ".planeteliege.com"});
    Cookies.remove("_ga",{ path: "/", domain: ".planeteliege.com"});
    Cookies.remove("_gat_gtag_UA_162272599_2",{ path: "/", domain: ".planeteliege.com"});
}

//Activate Google Maps via GDPR Cookie Consent
$('#allow-third-party').on('click',function(e){
    e.preventDefault();
    submitGroupConsent("default-third-party");
});
/*!
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */
var form_serialize = function (form) {

    // Setup our serialized data
    var serialized = [];

    // Loop through each field in the form
    for (var i = 0; i < form.elements.length; i++) {

        var field = form.elements[i];

        // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
        if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'button') continue;

        // If a multi-select, get all selections
        if (field.type === 'select-multiple') {
            for (var n = 0; n < field.options.length; n++) {
                if (!field.options[n].selected) continue;
                serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
            }
        }

        // Convert field data to a query string
        else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
            serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
        }
    }

    return serialized.join('&');

};

function submitGroupConsent(group) {
    $("#elc-cookie-consent-form input[name=group-"+group+"]").prop("checked",true);
    let form = document.querySelector('#elc-cookie-consent-form');
    let data = form_serialize(form);
    let xhr = new XMLHttpRequest();
    xhr.open('POST', form.dataset.url);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(data);
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            window.location.reload();    
        }
    }
}

